<!--  -->
<template>
  <div class="box">
    <div class="newsinfo">
      <div class="top">
        <router-link to="/">首页</router-link>><span>出版书籍<span>>{{bookInfo.bookName}}</span></span>
      </div>
      <div class="book-information">
            <div class="book-img">
                <a ><img
                  :src="`${IP_TEST}/uploads/${bookInfo.picsrc}`">
                </a>
            </div>
            <div class="book-info">
                <h1><em>《{{bookInfo.bookName}}》</em> <a class="writer default" target="_blank"></a></h1>
                        
                <p class="total">
                    <span>{{bookInfo.artvisits}}</span><em>次阅读</em>
                </p>
                <p class="intro">
                  【主编：{{bookInfo.zhuBian}}&nbsp;&nbsp;&nbsp;副主编：{{bookInfo.fuZhuBian}}】
                    <br>
                  【刊号：{{bookInfo.frequency}}】
                    <br>
                  【书籍分类：{{bookInfo.CategoryChild&&bookInfo.CategoryChild.name}}】
                    <br>
                  【出版社：{{bookInfo.press}}】
                    <br>
                  【出版日期：{{bookInfo.pubdate}}】
                </p>
                <p class="btn" v-if="bookInfo.BookChapters&&bookInfo.BookChapters.length>0&&bookInfo.BookChapters[0].BookChapterContents&&bookInfo.BookChapters[0].BookChapterContents.length>0">
                    <router-link class="border-btn J-getJumpUrl "
                        :to="`/bookartshow/${bookInfo.BookChapters[0].BookChapterContents[0].uuid}`">开始阅读</router-link>
                </p>
            </div>
      </div>
      <!-- start 区块导航 -->
      <div class="content-nav-wrap cf" data-l1="10">
          <div class="nav-wrap fl">
              <ul>
                 
                  <li class="j_catalog_block act">
                    <a class="lang"
                          href="" 
                        >目录<i><span id="J-catalogCount"></span></i>
                    </a></li>
              </ul>
          </div>
          <div class="update" v-if="lastBookArt">
              <p><router-link class="blue" :to="`/bookartshow/${lastBookArt.uuid}`"
                      target="_blank">更新至：{{lastBookArt.contentName}}</router-link><i>·</i><span>{{lastBookArt.createdAt|filterdate}}</span></p>
          </div>
      </div>
      <!-- end 区块导航 -->
     <div class="catalog-content-wrap catalog-page" id="j-catalogWrap">
          <div class="go-top-box" style="display: none;">
              <a href="javascript:" title="回到顶部"><em class="iconfont"></em></a>
          </div>
          <div class="volume-wrap">
              <div class="volume" v-for="(bookChapter,index) in bookInfo.BookChapters" :key="index">
                  <h3>
                      {{bookChapter.chapterName}}<i>·</i>共{{bookChapter.BookChapterContents.length}}篇
                  </h3>
                  <ul class="cf">
                      <li data-rid="1" v-for="(bookChapterContent,indexex) in bookChapter.BookChapterContents" :key="indexex"><router-link
                              :to="`/bookartshow/${bookChapterContent.uuid}`"
                              target="_blank">{{('000'+(indexex+1)).slice(-3)}}：{{bookChapterContent.contentName}}</router-link>
                      </li>
                  </ul>
              </div>
              
          </div>
      </div>
    </div>
     
  </div>
</template>

<script>
import { IP_TEST } from "@/config";
import {getBookInfo,getLastBookArt} from '@/request/get'
export default {
  data() {
    return {
      IP_TEST,
      lastBookArt:{},
      bookInfo:{}
    };
  },
  created(){
    this.getBookInfo();
    this.getLastBookArt();
  },
  components: {},

  mounted() {},
filters: {
    filterdate(date) {
      return date.slice(0, 10);
    }
  },
  methods: {
    async getBookInfo(){
      let bookId = this.$route.params.bookId;
      let bookInfo = await getBookInfo(bookId);
      this.bookInfo = bookInfo.data;
    },
    async getLastBookArt(){
       let bookId = this.$route.params.bookId;
      let lastBookArt = await getLastBookArt(bookId);
      this.lastBookArt = lastBookArt.data[0];
    }
  },
};
</script>
<style scoped>
/* .content{
  background-color: #f5f5f5 !important;
}
.footer{
  margin-top: 0px;
} */
.box {
  position: relative;
  width: 100%;
  background-color: #f5f5f5;
}
.newsinfo {
  position: relative;
  width: 1300px;
  /* min-height: 1245px; */
  margin: 0 auto;
  overflow: hidden;
}
.newsinfo > .top {
  position: relative;
  margin-top: 27px;
  height: 14px;
  font-size: 14px;

  font-weight: 500;
  color: #333;
  line-height: 14px;
}
.book-information {
  position: relative;
  /* z-index: 2; */
  margin-bottom: 20px;
  margin-top: 20px;
  padding-bottom: 20px;
  border-radius: 6px;
  background: #fff;
  display: -webkit-box;
}
.book-information .book-img {
  float: left;
  width: 180px;
  height: 240px;
  margin: 20px 20px 0;
  border: none;
}
.book-img {
  width: 72px;
  height: 96px;
  margin-right: 12px;
  border: 1px solid #e6e6e6;
}
.book-img a {
  position: relative;
  z-index: 1;
  display: block;
  overflow: hidden;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3), 0 0 5px #f9f2e9 inset;
}
.book-img a img {
  width: 100%;
  height: 100%;
  -webkit-transition: -webkit-transform 0.3s ease-out;
  -moz-transition: -moz-transform 0.3s ease-out;
  -ms-transition: -ms-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  color: #fcfcfa;
}
.book-img a span {
  font: 12px/18px Arial;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 17px;
  padding: 0 3px 0 2px;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 0 0;
  background: #ed4259;
}
.book-information .book-img a,
.book-information .book-img img {
  display: block;
}

.book-information .book-img img:hover {
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
}

.book-information .book-info {
  position: relative;
  z-index: 1;
  float: left;
  width: 780px;
  min-height: 246px;
  margin-top: 14px;
  text-align: justify;
}
.book-information .book-info h1 {
  font: 700 28px/38px PingFangSC-Regular, HelveticaNeue-Light,
    "Helvetica Neue Light", "Microsoft YaHei", sans-serif;
  overflow: hidden;
  height: 38px;
  margin-bottom: 8px;
}
.book-information .book-info h1 a {
  font: 14px/38px PingFangSC-Regular, "-apple-system", Simsun;
  margin-left: 3px;
  color: #1a1a1a;
}
.book-information .book-info h1 a:hover {
  color: #1a1a1a;
}

.book-information .book-info p {
  font: 14px/24px PingFangSC-Regular, "-apple-system", Simsun;
}
.book-information .book-info p.tag-box {
  margin-bottom: 1px;
}
.book-information .book-info p.tag-box .tag {
  margin: 6px 12px 0 0;
}
.book-information .book-info p.tag-box .tag a,
.book-information .book-info p.tag-box .tag i {
  font: 12px/18px PingFangSC-Regular, "-apple-system", Simsun;
  display: inline-block;
  height: 18px;
  margin-right: 6px;
  padding: 0 4px;
  text-align: center;
  vertical-align: top;
  color: var(--color-primary);
  border-width: 1px;
  border-style: solid;
  border-color: var(--color-primary);
  border-radius: 2px;
}
.book-information .book-info p.tag-box .tag i.blue {
  color: #2972cc;
  border: 1px solid #4284ed;
}
.book-information .book-info p.tag-box .tag i.org {
  color: #ff7e00;
  border: 1px solid #ff7e00;
}
.book-information .book-info p.tag-box .tag i.red {
  color: #fc387e;
  border: 1px solid #fd9bbe;
}
.book-information .book-info p.tag-box .tag + .intro {
  font: 14px/20px PingFangSC-Regular, "-apple-system", Simsun;
  overflow: hidden;
  height: 20px;
  margin-bottom: 11px;
}
.book-information .book-info p.total {
  font-size: 0;
  margin-bottom: 5px;
  margin-left: 5px;
}
.book-information .book-info p.total em,
.book-information .book-info p.total i,
.book-information .book-info p.total span {
  display: inline-block;
  vertical-align: middle;
}
.book-information .book-info p.total span {
  font: 18px/20px Arial;
  margin-top: -2px;
  margin-right: 5px;
  color: #1a1a1a;
}
.book-information .book-info p.total em {
  font: 12px/20px PingFangSC-Regular, "-apple-system", Simsun;
}
.book-information .book-info p.total i {
  font-size: 16px;
  margin: -3px 10px 0;
  color: #a6a6a6;
}
.book-information .book-info p.intro {
  overflow: hidden;
  height: 117px;
  margin-bottom: 19px;
  line-height: 30px;
  font-size: 16px;
}
.book-information .book-info p.intro.show {
  overflow: auto;
  height: auto;
  padding-bottom: 30px;
}

.book-information .book-info .btn {
  font-size: 0;
}
.book-information .book-info .btn > a {
  font: 14px/34px PingFangSC-Regular, "-apple-system", Simsun;
  position: relative;
  display: inline-block;
  overflow: visible;
  width: 120px;
  height: 34px;
  margin-right: 20px;
  text-align: center;
  vertical-align: middle;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
}
.book-information .book-info .btn > a .download-qrcode {
  position: absolute;
  z-index: 1000;
  top: -10px;
  left: 50%;
  display: block;
  box-sizing: border-box;
  padding: 20px;
  transform: translate(-50%, -100%);
  text-align: center;
  border: 1px solid var(--color-primary-ligher);
  border-radius: 8px;
  background: #fff;
}
.book-information .book-info .btn > a .hover2show {
  display: none;
}
.book-information .book-info .btn > a:hover .hover2show {
  display: block;
}
.book-information .book-info .btn .iconfont {
  font-size: 14px;
  width: 14px;
  margin: -3px 6px 0 0;
}

.content-nav-wrap {
  height: 48px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e6e6e6
}
.content-nav-wrap .nav-wrap li {
  font: 18px/48px FZZCYSK;
  float: left;
  overflow: hidden;
  height: 47px;
  text-align: center;
   margin-bottom: -1px;
  border-bottom: 2px solid #2C9D51
}
.content-nav-wrap .nav-wrap li a {
  display: block;
  overflow: hidden;
  padding: 0 20px;
  color:#2C9D51
  /* color: #1a1a1a */
}
.content-nav-wrap .nav-wrap li a i {
  font: 14px/48px FZZCYSK
}
.content-nav-wrap .update {
  font: 14px/48px PingFangSC-Regular,'-apple-system',Simsun;
  float: left;
  padding-left: 30px;
  color: #2972cc
}
.content-nav-wrap .update i {
  font-family: Arial;
  margin: 0 8px 0 2px
}


.catalog-content-wrap {
  border-radius: 6px;
  margin-bottom: 30px;
}
.catalog-content-wrap.catalog-page {
  padding: 20px;
  background: #fff;
  /* margin-bottom: 20px; */
}
.catalog-content-wrap.subscribe-content {
  padding: 16px 0 100px
}
.catalog-content-wrap .loading {
  padding-top: 135px;
  text-align: center
}
.catalog-content-wrap .loading .la-ball-pulse {
  margin: 0 auto
}
.catalog-content-wrap .no-data .null {
  width: 142px;
  height: 100px;
  margin: 0 auto 20px;
  background: url(/pro/xs8_pc/_prelease/images/common/big_wu.ba1a4.png)
}
.catalog-content-wrap .no-data p {
  font: 14px/32px PingFangSC-Regular,'-apple-system',Simsun;
  text-align: center;
  color: #666
}
.volume {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin-top: 40px
}
.volume:first-child {
  margin-top: 0
}
.volume ul {
  overflow: hidden;
  width: 1300px;
}
.volume h3 {
  font: 700 18px/24px PingFangSC-Regular,HelveticaNeue-Light,'Helvetica Neue Light','Microsoft YaHei',sans-serif;
  overflow: hidden;
  height: 24px;
  padding-bottom: 11px;
  border-bottom: 1px solid #e6e6e6
}
.volume h3 span {
  font: 12px/16px PingFangSC-Regular,'-apple-system',Simsun;
  display: inline-block;
  min-width: 24px;
  margin: -1px 8px 0;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  color: #fff
}
.volume h3 span.free {
  background: #8ccd0a
}
.volume h3 span.vip {
  background: #fc6c28
}
.volume h3 i {
  font-family: Arail
}
.volume h3 .count {
  font: 14px/19px PingFangSC-Regular,'-apple-system',Simsun;
  color: #666
}
.volume h3 .count cite {
  font-family: Arial;
  margin: 0 3px
}
.volume h3 .subscri,
.volume h3 .subscribe {
  position: relative;
  z-index: 2;
  float: right
}
.volume h3 .subscri .btn,
.volume h3 .subscribe .btn {
  font: 14px/28px PingFangSC-Regular,'-apple-system',Simsun;
  position: absolute;
  z-index: 2;
  right: 0;
  display: block;
  width: 96px;
  height: 28px;
  transition: background-color .5s;
  text-align: center;
  color: #fff;
  background: #bf2c24
}
.volume h3 .subscri .btn b,
.volume h3 .subscribe .btn b {
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  margin-right: 3px;
  vertical-align: 0
}
.volume h3 .subscri strong,
.volume h3 .subscribe strong {
  font: 14px/24px PingFangSC-Regular,'-apple-system',Simsun;
  position: absolute;
  z-index: 1;
  top: 2px;
  right: 88px;
  transition: right ease-out .5s;
  text-align: center;
  color: #bf2c24
}
.volume h3 .subscri:hover strong,
.volume h3 .subscribe:hover strong {
  right: 94px
}
.volume h3 .subscri:hover em,
.volume h3 .subscribe:hover em {
  background: var(--color-primary)
}
.volume li {
  font: 14px/40px PingFangSC-Regular,'-apple-system',Simsun;
  float: left;
  overflow: hidden;
  width: 1300px;
  height: 40px;
  padding-right: 60px;
  border-top: 1px solid #ebebeb
}
.volume li:first-child {
  border-top: none
}
.volume li a {
  float: left;
  overflow: hidden;
  max-width: 1300px;
  white-space: nowrap;
  color: #262626;
  text-overflow: ellipsis
}
.volume li .iconfont {
  font-size: 16px;
  float: right;
  color: #bfbfbf
}
</style>
